/**
 * @type module
 * Moduł inicjalizujący
 */
app.service('shopLocatorView', function(shopLocator) {
	function init(){
		shopLocator.init();
	}

	return {
		init: init
	};
});
